import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Table,
  Form,
  FormGroup,
  Label,
  Input
} from "reactstrap";
import { Link, Redirect } from "react-router-dom";
// react plugin used to create charts
import { Line } from "react-chartjs-2";
// react plugin for creating vector maps
import { VectorMap } from "react-jvectormap";
import axios from "axios";

import {
  PanelHeader,
  Stats,
  Statistics,
  CardCategory,
  Progress,
  Button,
  Timespanpicker
} from "components";

import {
  dashboardPanelChart,
  dashboardActiveUsersChart,
  dashboardSummerChart,
  dashboardActiveCountriesCard
} from "variables/charts.jsx";

import jacket from "assets/img/saint-laurent.jpg";
import shirt from "assets/img/balmain.jpg";
import swim from "assets/img/prada.jpg";

import { table_data } from "variables/general.jsx";
import moment from "moment";
import {Timepicker} from 'react-timepicker';
import 'react-timepicker/timepicker.css';
import { faThemeisle } from "@fortawesome/free-brands-svg-icons";

// import TextField from '@mui/material/TextField';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { TimePicker } from '@mui/x-date-pickers/TimePicker';
var timeOutChecker = null;

class CheckersList extends React.Component {
  constructor(props) {
    super(props);
    moment.locale("es");
    /* ////console.log("########## PROPS ###########");
    ////console.log(props); */
    let myCompany = null;
    if (this.props.myCompany) {
      myCompany = this.props.myCompany;
    } else {
      myCompany = (this.props.mainState && this.props.mainState.myCompany) ? this.props.mainState.myCompany : null;
    }

    let myCheckers = null;
    if (this.props.myCompanyCheckers) {
      myCheckers = this.props.myCompanyCheckers;
    } else {
      myCheckers = (myCompany && this.props.mainState.myCompanyCheckers && this.props.mainState.myCompanyCheckers[myCompany.uuid]) ? this.props.mainState.myCompanyCheckers[myCompany.uuid] : null;
    }

    // let myEmployees = null;
    // if (this.props.myEmployees) {
    //   myEmployees = this.props.myEmployees;
    // } else {
    //   myEmployees = (myCompany && this.props.mainState.myEmployees && this.props.mainState.myEmployees[myCompany.uuid]) ? this.props.mainState.myEmployees[myCompany.uuid] : null;
    // }

    this.state = {
      myCompany: myCompany,
      myCheckers: myCheckers,
      // myEmployees: myEmployees,
      servicesSize: "auto"
    };

    this.loadMyCompanyCheckers = this.loadMyCompanyCheckers.bind(this);

    // this.createCompanyCardContent(this);
    // this.handleMyCompanyFieldChange.bind(this);
    this.handleNewCheckerFieldChange.bind(this);
    this.handleEntityFieldChange.bind(this);
    // this.loadMyEmployees.bind(this);
    // this.saveMyCompany.bind(this);
    this.buildCheckers.bind(this);

    // let externalUsers = [
    //   "Oniti"
    // ];
    // if (externalUsers.indexOf(this.props.mainState.user.name) > -1) {
    //   this.props.history.push("/clientes");
    // }
  }
  componentDidMount() {
    this.loadMyCompanyCheckers();
    // this.loadMyEmployees();
  }
  componentWillUnmount() {
    // this.props.saveMyCompany(this.state.myCompany);
    // this.props.saveMyCompanyWorkplaces(this.state.myCheckers);
    // this.props.saveMyEmployees(this.state.myEmployees);
    if (this.timeOutChecker) {
      clearTimeout(this.timeOutChecker);
    }
    this.props.saveMyCheckers(this.state.myCheckers);
  }
  async loadMyCompanyCheckers(company_id) {
    if (!company_id) company_id = this.state.myCompany.uuid;
    this.setState({ isLoadingMyCheckers: true });
    this.props.loadMyCompanyCheckers(company_id).then(result => {
      this.setState({
        isLoadingMyCheckers: false,
        myCheckers: result.ok ? result.checkers : []
      });
    })
    .catch((error) => {
      // Error 😨
      console.log("Error al cargar los fichadores de mi empresa: " + error.message);
      // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
    });
  }
  async saveChecker(checker) {
    this.setState({
      createChecker: false,
      editChecker: false,
      isSavingChecker: true
    });
    checker = checker || this.state.newChecker;
    checker.company = this.state.myCompany.uuid;
    checker = {
      id: checker.id || null,
      name: checker.name,
      pairingCode: checker.pairingCode,
      company: checker.company
    };
    if (checker.id) {
      let editingChecker = this.state.editingChecker;
      if (!editingChecker) editingChecker = [];
      editingChecker[checker.id] = true;
      this.setState({
        editingChecker: editingChecker
      });
    } else {
      // As is new, we put it in the list so could be already displayed as pairing
      let checkers = this.state.myCheckers;
      if (!checkers) checkers = [];
      checker.isNew = true;
      checker.status_id = 403;
      checker.status = "Emparejando";
      checkers["new"] = checker;
    }
    // console.log("saveChecker:", checker);
    // return;
    this.props.saveChecker(checker).then(result => {
      this.setState({
        isSavingChecker: false,
        newChecker: null
      });
      if (checker.id) {
        let myCheckers = this.state.myCheckers;
        if (!myCheckers) myCheckers = [];
        myCheckers[checker.id] = result.checker;
        let editingChecker = this.state.editingChecker;
        if (!editingChecker) editingChecker = [];
        editingChecker[checker.id] = false;
        this.setState({
          editingChecker: editingChecker,
          myCheckers: myCheckers
        });
        // this.loadMyCompanyCheckers();
      }
      this.loadMyCompanyCheckers();
    })
    .catch((error) => {
      // Error 😨
      console.log("Error al guardar mi fichador: " + error.message);
      // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
    });
  }
  handleMyCompanyFieldChange(field, value) {
    this.handleEntityFieldChange("myCompany", field, value);
    // let myCompany = this.state.myCompany;
    // if (!myCompany) myCompany = {};
    // myCompany[field] = value;
    // this.setState({ myCompany: myCompany });
  }
  handleNewCheckerFieldChange(field, value) {
    this.handleEntityFieldChange("newChecker", field, value);
    // let newChecker = this.state.newChecker;
    // if (!newChecker) newChecker = {};
    // newChecker[field] = value;
    // this.setState({ newChecker: newChecker });
  }
  handleEntityFieldChange(entity_name, field, value) {
    let entity = this.state[entity_name];
    if (!entity) entity = {};
    entity[field] = value;
    this.setState({ [entity_name]: entity });
  }
  buildCheckers() {
    let content = null;
    let isPairing = false;
    if (this.state.isLoadingMyCheckers && !this.state.myCheckers) {
      content = (
        <Col xs={12} md={12}>
          <CardTitle><i className="now-ui-icons arrows-1_refresh-69 spin" /></CardTitle>
        </Col>
      );
    } else {
      if (this.state.createChecker || this.state.editChecker) {
        let newChecker = this.state.newChecker;
        if(!newChecker) newChecker = {}; 
        let name = (newChecker && newChecker.name) ? newChecker.name : "";
        let pairingCode = (newChecker && newChecker.pairingCode) ? newChecker.pairingCode : "";
        content = (
          <Row className="text-left workplace-info new-workplace">
            <Col xs={12} md={12}>
              <CardHeader>
                <b>
                  {newChecker.isNew ? (<span><i className="now-ui-icons ui-1_simple-add" /> Nuevo fichador</span>) : (<span><i className="fa fa-edit" /> Editar fichador</span>)}
                </b>
              </CardHeader>
            </Col>
            <Col xs={12} md={12}>
              <Label md={3}>Nombre</Label>
              <FormGroup>
                <Input
                  type="text"
                  name="checkerName"
                  placeholder="Fichador entrada"
                  value={name}
                  onChange={event =>
                    this.handleNewCheckerFieldChange("name", event.target.value)
                  }
                />
              </FormGroup>
            </Col>
            <Col xs={12} md={12}>
              <Label md={3}>Código</Label>
              <FormGroup>
                <Input
                  type="text"
                  name="pairingCode"
                  placeholder="1A2B3C"
                  value={pairingCode}
                  onChange={event =>
                    this.handleNewCheckerFieldChange("pairingCode", event.target.value)
                  }
                />
              </FormGroup>
            </Col>
            <Col xs={6}>
              <Button 
                block 
                color="success" 
                size="lg"
                onClick={() => {
                  this.saveChecker();
                  // this.setState({ createCompany: false });
                }}
                >
                Guardar
              </Button>
            </Col>
            <Col xs={6}>
              <Button 
                block 
                color="default" 
                size="lg"
                onClick={() => {
                  this.setState({
                    createChecker: false,
                    newChecker: null,
                    editChecker: null
                  });
                }}
                >
                Cancelar
              </Button>
            </Col>
          </Row>
        );
      } else {
        if (this.state.myCheckers && Object.keys(this.state.myCheckers).length > 0) {
          let checkers = [];
          let checkersIds = Object.keys(this.state.myCheckers);
          let size = checkersIds.length;
          size = {
            xs: 12,
            md: 4,
            lg: 4,
            xl: 3
          };
          checkersIds.map(checkerId => {
            let checker = this.state.myCheckers[checkerId];
            let bodyContent = null;
            let specialColor = false;
            let backgroundColor = "";
            let statusIcon = null;
            // if (checker.isNew) {
            //   bodyContent = <span><i className="now-ui-icons arrows-1_refresh-69 spin" /> Guardando</span>;
            //   specialColor = true;
            // } else if (this.state.editingChecker && this.state.editingChecker[checkerId]) {
            //   bodyContent = <span><i className="now-ui-icons arrows-1_refresh-69 spin" /> Guardando</span>;
            //   specialColor = true;
            // } else {
              bodyContent = checker.status; // + " (" + checker.pairing_code + ")";
            // }
            switch (parseInt(checker.status_id)) {
              case 400:
                // Activo
                backgroundColor = "bg-green";
                break;
              case 402:
                // Eliminado
                backgroundColor = "bg-red";
                break;
              case 403:
                // Emparejando
                backgroundColor = "bg-yellow";
                isPairing = true;
                statusIcon = <i className="now-ui-icons arrows-1_refresh-69 spin" />;
                break;
              case 401:
                // Inactivo
                backgroundColor = "bg-gray";
                break;
              default:
                break;
            }
            let options = null;
            if (this.state.openOptions === checkerId) {
              bodyContent = (
                <Row id="edit-workplace-buttons">
                  <Col xs={6}>
                    <Button
                      onClick={() => {
                        this.setState({
                          editChecker: checker.id,
                          openOptions: null,
                          newChecker: {
                            id: checker.id,
                            name: checker.name,
                            pairingCode: checker.pairing_code
                          }
                        });
                      }}
                      color="primary"
                      size="lg"
                      round
                      // icon
                      disabled={this.state.isSavingChecker}
                    >
                      <i className="fa fa-edit" /> Editar
                      {/* <i className={this.state.isSavingMyCompany ? "now-ui-icons arrows-1_refresh-69 spin reposition-spin" : "fa fa-edit"} /> */}
                    </Button>
                  </Col>
                  <Col xs={6}>
                    <Button
                      onClick={() => {
                        this.setState({
                          openOptions: null
                        });
                      }}
                      color="danger"
                      size="lg"
                      round
                      // icon
                      disabled={this.state.isSavingChecker}
                    >
                      <i className="fa fa-trash" /> Eliminar
                      {/* <i className={this.state.isSavingMyCompany ? "now-ui-icons arrows-1_refresh-69 spin reposition-spin" : "fa fa-edit"} /> */}
                    </Button>
                  </Col>
                </Row>
              );
              options = (
                <div className="corner-action-icon delete-workplace">
                  <Button
                    onClick={() => {
                      this.setState({
                        openOptions: null
                      });
                    }}
                    color="primary"
                    size="sm"
                    round
                    icon
                    // disabled={this.state.isSavingMyCompany}
                  >
                    <i className="now-ui-icons ui-1_simple-remove" />
                    {/* <i className={this.state.isSavingMyCompany ? "now-ui-icons arrows-1_refresh-69 spin reposition-spin" : "fa fa-edit"} /> */}
                  </Button>
                </div>
              );
            } else {
              options = (
                <div className="corner-action-icon delete-workplace">
                  <Button
                    onClick={() => {
                      this.setState({
                        openOptions: checker.id
                      });
                    }}
                    color="primary"
                    size="sm"
                    round
                    icon
                    // disabled={this.state.isSavingMyCompany}
                  >
                    <i className="fa fa-ellipsis-v" />
                    {/* <i className={this.state.isSavingMyCompany ? "now-ui-icons arrows-1_refresh-69 spin reposition-spin" : "fa fa-edit"} /> */}
                  </Button>
                </div>
              );
            }
            checkers.push(
              <Col {...size} key={checker.id}>
                <Card className={"workplace-info card-stats plain " + (specialColor ? "workplace-editing" : "") + " " + backgroundColor}>
                  <CardHeader>
                    <b>
                      <i className="fa fa-building" /> {checker.name}
                    </b>
                    {options}
                  </CardHeader>
                  <CardBody className="text-center">
                    <span className={"checker-status " + backgroundColor}>
                      {statusIcon} {bodyContent}
                    </span>
                  </CardBody>
                </Card>
              </Col>
            );
          });
          content = <Row>{checkers}</Row>;
        } else {
          content = (
            <Row>
              <Col xs={12} md={12}>
                No hay fichadores
                <Button 
                  block 
                  color="primary" 
                  size="lg"
                  disabled={this.state.isSavingChecker}
                  onClick={() => {
                    this.setState({
                      newChecker: {
                        isNew: true
                      },
                      createChecker: true
                    });
                  }}
                  >
                  {!this.state.isSavingChecker ?
                    (<span><i className="now-ui-icons ui-1_simple-add" /> Emparejar fichador</span>) :
                    (<span><i className="now-ui-icons arrows-1_refresh-69 spin" /> Emparejando</span>)
                  }
                </Button>
              </Col>
            </Row>
          );
        }
      }
    }
    let card = (
      <Col xs={12}>
        <Card className="my-company-workplaces-info card-stats plain">
          <CardHeader>
            <b>
              <i className="fa fa-building" /> Mis fichadores
            </b>
            {(this.state.myCheckers && !this.state.createChecker) && <div className="corner-action-icon">
                <Button
                  onClick={() => {
                    this.setState({
                      newChecker: { isNew: true },
                      createChecker: true
                    });
                  }}
                  color="primary"
                  size="sm"
                  round
                  icon
                  disabled={this.state.isSavingMyCompany}
                >
                  <i className="now-ui-icons ui-1_simple-add" />
                  {/* <i className={this.state.isSavingMyCompany ? "now-ui-icons arrows-1_refresh-69 spin reposition-spin" : "fa fa-edit"} /> */}
                </Button>
              </div>
            }
          </CardHeader>
          <CardBody>
            {content}
          </CardBody>
        </Card>
      </Col>
    );
    if (isPairing) {
      if (!this.timeOutChecker) {
        this.timeOutChecker = setTimeout( function() {
          this.loadMyCompanyCheckers();
        }.bind(this), 5000);
      }
    }
    return card;
  }
  render() {
    // console.log("this.state", this.state);
    return (
      <div>
        <PanelHeader
          size="sm"
          // content={this.createMyCompanyCard()}
        />
        <div className="content">
          <Row>
          </Row>
          <Row>
            {/* {this.createMyCompanyCard()} */}
            {this.buildCheckers()}
          </Row>
        </div>
      </div>
    );
  }
}

export default CheckersList;



// WEBPACK FOOTER //
// ./src/views/CheckIn/CheckersList.jsx